import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

export const IdentitySessionCookieName = 'UiPathIdentitySessionId';

export function setIdentityCookie() {
    if (Cookies.get(IdentitySessionCookieName)) {
        return;
    }

    Cookies.set(IdentitySessionCookieName, uuidv4(), {
        path: '/',
        secure: false,
    });
}

export function removeIdentityCookie() {
    Cookies.remove(IdentitySessionCookieName, {
        path: '/',
        domain: window.location.hostname,
        secure: false,
    });
}

export function getIdentityCookie() {
    return Cookies.get(IdentitySessionCookieName);
}
